import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/views/404/notFound.vue'
import LoadingPage from '@/views/loadingPage/loadingPage';
import Login from '@/views/login/login';
import Home from '@/views/home/home';
import Authorize from '@/views/authorize/authorize';
import Log from '@/views/log/log';
import Role from '@/views/role/role';
import GoodList from '@/views/goodList/goodList';
import Index from '@/views/index';
import Categories from '@/views/categories/categories';
import BrandList from '@/views/brandList/brandList';
import OrderList from '@/views/orderList/orderList';
import OrderDetail from '@/views/orderList/orderDetail';
import ManagerList from '@/views/managerList/managerList';
import UserList from '@/views/userList/userList';
import UserEdit from '@/views/userList/formUserList';
import ArticleList from '@/views/articleList/articleList';
import ArticleListDetail from '@/views/articleList/articleListDetail'
import RotationChart from '@/views/rotationChart/rotationChart';
import CustomPage from '@/views/customPage/customPage';
import Region from '@/views/region/region';
import Price from '@/views/price/price';
import Shipping from '@/views/shipping/shipping.vue';
import Navigator from '@/views/navigation/navigation.vue';
import ArticleClassification from '@/views/articleClassification/articleClassification.vue'
import Ali_oss from '@/views/ali_oss/ali_oss'
import Ali_email from '@/views/ali_email/ali_email.vue'
import Ali_sms from '@/views/ali_sms/ali_sms.vue'
import Upload from '@/views/upload/upload.vue'
import Other from '@/views/other/other.vue'
import Kuaidi100 from '@/views/kuaidi100/kuaidi100.vue'
import VipGrade from '@/views/vipGrade/vipGrade.vue'
import Manufacturer from '@/views/manufacturer/manufacturer.vue'
import OrderLog from '@/views/orderLog/orderLog.vue';
import RefundList from '@/views/orderList/refundList.vue';
import AdvancePayment from '@/views/orderList/advanceList.vue';
import DistributionSettings from '@/views/distribution/distributionSetting.vue';
import WithdrawalSettings from '@/views/distribution/withdrawalSettings.vue';
import DistributionUser from '@/views/distribution/distributionUser.vue';
import RevenueBreakdown from '@/views/distribution/revenueBreakdown.vue';
import WithdrawalList from '@/views/distribution/withdrawalList.vue';
Vue.use(Router)

/**
 * 登入之后除了首页之外
 * 其他页面都会设置缓存，路由路径只能设置一个斜杆,
 * 路由的{name}字段和路径名必须是一样的
 * 便于路由缓存
 */
export const cacheChildren = [
  {
    path: '/authorize',
    name: 'authorize',
    meta: { title: '权限控制' },
    component: Authorize
  },
  {
    path: '/log',
    name: 'log',
    meta: { title: '操作日志' },
    component: Log
  },
  {
    path: '/role',
    name: 'role',
    meta: { title: '角色管理' },
    component: Role,
  },
  {
    path: '/goodList',
    name: 'goodList',
    meta: { title: '商品列表' },
    component: GoodList
  },
  {
    path: '/categories',
    name: 'categories',
    meta: { title: '商品分类' },
    component: Categories,
  },
  {
    path: '/brandList',
    name: 'brandList',
    meta: { title: '品牌列表' },
    component: BrandList,
  },
  {
    path: '/orderList',
    name: 'orderList',
    meta: { title: '订单列表' },
    component: OrderList,
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    meta: { title: '订单详情' },
    component: OrderDetail,
  },
  {
    path: '/managerList',
    name: 'managerList',
    meta: { title: '管理员列表' },
    component: ManagerList,
  },
  {
    path: '/userList',
    name: 'userList',
    meta: { title: '用户列表' },
    component: UserList,
  },
  {
    path: '/userEdit',
    name: 'userEdit',
    meta: { title: '用户详情' },
    component: UserEdit,
  },
  {
    path: '/articleList',
    name: 'articleList',
    meta: { title: '文章列表' },
    component: ArticleList,
  },{
    path: '/articleListDetail',
    name: 'articleListDetail',
    meta: { title: '文章详情' },
    component: ArticleListDetail
  },{
    path: '/rotationChart',
    name: 'rotationChart',
    meta: { title: '首页轮播' },
    component: RotationChart
  },{
    path: '/customPage',
    name: 'customPage',
    meta: { title: '自定义页面' },
    component: CustomPage
  },{
    path: '/region',
    name: 'region',
    meta: { title: '地区管理' },
    component: Region
  },{
    path: '/price',
    name: 'price',
    meta: { title: '筛选价格' },
    component: Price
  },
  {
    path: '/shipping',
    name: 'shipping',
    meta: { title: '快递管理' },
    component: Shipping
  },{
    path: '/navigation',
    name: 'navigation',
    meta: { title: '导航管理' },
    component: Navigator
  },{
    path: '/articleClassification',
    name: 'articleClassification',
    meta: { title: '文章分类管理' },
    component: ArticleClassification
  },{
    path: '/ali_oss',
    name: 'ali_oss',
    meta: { title: '阿里OSS' },
    component: Ali_oss
  },{
    path: '/ali_email',
    name: 'ali_email',
    meta: { title: '阿里EMAIL' },
    component: Ali_email
  },{
    path: '/ali_sms',
    name: 'ali_sms',
    meta: { title: '阿里短信'},
    component: Ali_sms
  },{
    path: '/upload',
    name: 'upload',
    meta: { title: '上传配置'},
    component: Upload
  }
  ,{
    path: '/other',
    name: 'other',
    meta: { title: '站点设置'},
    component: Other
  }
  ,{
    path: '/kuaidi100',
    name: 'kuaidi100',
    meta: { title: '快递100'},
    component: Kuaidi100
  },
  {
    path: '/vipGrade',
    name: 'vipGrade',
    meta: { title: '会员等级' },
    component: VipGrade,
  },
  {
    path: '/manufacturer',
    name: 'manufacturer',
    meta: { title: '生产厂商' },
    component: Manufacturer,
  },
  {
    path: '/orderLog',
    name: 'orderLog',
    meta: { title: '订单日志' },
    component: OrderLog,
  },
  {
    path: '/refundList',
    name: 'refundList',
    meta: { title: '退款/退货单' },
    component: RefundList,
  },
  {
    path: '/advancePayment',
    name: 'advancePayment',
    meta: { title: '预付款订单' },
    component: AdvancePayment,
  },
  {
    path: '/distributionSettings',
    name: 'distributionSettings',
    meta: { title: '分销设置' },
    component: DistributionSettings,
  },
  {
    path: '/withdrawalSettings',
    name: 'withdrawalSettings',
    meta: { title: '提现设置' },
    component: WithdrawalSettings,
  },
  {
    path: '/distributionOrders',
    name: 'distributionOrders',
    meta: { title: '分销订单' },
    component: OrderList,
  },
  {
    path: '/distributionUser',
    name: 'distributionUser',
    meta: { title: '分销用户' },
    component: DistributionUser,
  },
  {
    path: '/distributionUnderorders',
    name: 'distributionUnderorders',
    meta: { title: '下级订单' },
    component: OrderList,
  },
  {
    path: '/revenueBreakdown',
    name: 'revenueBreakdown',
    meta: { title: '收益详情' },
    component: RevenueBreakdown,
  },
  {
    path: '/withdrawalList',
    name: 'withdrawalList',
    meta: { title: '提现列表' },
    component: WithdrawalList,
  },
];

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/loading'
    },
    {
      path: '/loading',
      component: LoadingPage
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/Index',
      component: Index,
      redirect: '/home',
      children: [
        {
          path: '/home',
          name: 'home',
          component: Home,
        },
        ...cacheChildren
      ]
    },
    {
      path: '*',
      components: {
        notFound: NotFound
      }
    }
  ]
})